import axiosClient from "../../../../../system/helpers/axiosConfig";
import { getLocale } from "../../../../../system/helpers/localstorageHelper";

export const getTranslationList = (params) => {
  const locale = getLocale();
  return axiosClient
    .get("api/translations/manage/" + locale, { params })
    .then((r) => r.data);
};
